import {
  Box,
  CircularProgress,
  Typography,
  makeStyles,
  Grid,
} from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import styles from './styles';

export interface FilteredItemsCounterProps {
  countFilteredItems?: number;
  countTotalItems?: number;
  isLoading: boolean;
  totalItemsText: string;
}
const FilteredItemsCounter = ({
  countFilteredItems = 0,
  countTotalItems = 0,
  isLoading,
  totalItemsText,
}: FilteredItemsCounterProps) => {
  const classes = makeStyles(styles)();

  return (
    <Grid container className={classes.container}>
      {isLoading ? (
        <CircularProgress size={10} />
      ) : (
        <>
          <Typography className={classes.text}>
            {`${totalItemsText}:`}
            <Box className={classes.counter}>{countTotalItems}</Box>
          </Typography>
          <Typography className={classes.divider} variant="body2">
            {'/'}
          </Typography>
          <Typography className={classes.text}>
            {`${i18n.t('FILTERED_TOTAL_KEY')}:`}

            <Box className={classes.counter}>{countFilteredItems || 0}</Box>
          </Typography>
        </>
      )}
    </Grid>
  );
};

export default FilteredItemsCounter;
